import { LightningElement, api } from "lwc";
import { logger } from "@devforce/trailhead-client-logger";
import formControlCombobox from "./formControlCombobox.html";
import formControlSelect from "./formControlSelect.html";
import formControl$1 from "./formControl.html";

class formControl extends LightningElement {
  @api config = null;

  render() {
    if (!this.config) {
      logger.error("Missing form control configuration.");
      return formControl$1;
    }

    switch (this.config.type) {
      case "combobox":
        return formControlCombobox;

      case "select":
        return formControlSelect;

      default:
        return formControl$1;
    }
  }

  handleChange(e) {
    this.dispatchEvent(
      new CustomEvent("change", {
        detail: {
          id: this.config.id,
          value: e.detail,
        },
      })
    );
  }
}

export default formControl;
